import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';
import InputMask from 'react-input-mask';

import { fetchAll, fetchOne } from '../../lib/v31lib';
import { loginAtom } from '../../lib/auth';

import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from '@mui/material';

import {
  Page,
  StyledButton,
  StyledSelect,
  Typography
} from '../../components/interface';

import LaunchIcon from '@mui/icons-material/Launch';

import {
  BookYear,
  Emission
} from '../../models';

const { DateTime } = require("luxon");

type Props = {};
type RawExportStat = {
  custom_result: any
};

export const SeafIndex: FunctionComponent<Props> = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  
  const [login, setLogin] = useAtom(loginAtom);
  const [bookYear, setBookYear] = useState<number>();
  const [bookYearMinus1, setBookYearMinus1] = useState<number>();
  const [bookYearMinus2, setBookYearMinus2] = useState<number>();
  const [emissionId, setEmissionId] = useState<number>();
  const [failE1, setFailE1] = useState<boolean>(false);
  const [failE2, setFailE2] = useState<boolean>(false);
  const [failE3, setFailE3] = useState<boolean>(false);
  const [failE4, setFailE4] = useState<boolean>(false);
  const [failE5, setFailE5] = useState<boolean>(false);
  const [successE1, setSuccessE1] = useState<boolean>(false);
  const [successE2, setSuccessE2] = useState<boolean>(false);
  const [successE3, setSuccessE3] = useState<boolean>(false);
  const [successE4, setSuccessE4] = useState<boolean>(false);
  const [successE5, setSuccessE5] = useState<boolean>(false);
  const [activeMonth, setActiveMonth] = useState<string>(DateTime.now().toFormat("LL/yyyy"));

  const {
    data: bookYears,
    // isLoading: bookYearsLoading,
    // isError: bookYearsError,
    // isSuccess: bookYearsSuccess,
    // refetch: bookYearsRefetch,
  } = useQuery({
    queryKey: ["book_years"],
    queryFn: () =>
      fetchAll<BookYear>(
        "/nl/v3/objects/fetch_all",
        {
          object: "book_year",
          fields: ["id", "short_visual"],
          order: "id DESC"
        },
        login
      ),
    enabled: !!login
  });
  const {
    data: emissions,
    // isLoading: bookYearsLoading,
    // isError: bookYearsError,
    // isSuccess: bookYearsSuccess,
    // refetch: bookYearsRefetch,
  } = useQuery({
    queryKey: ["emissions"],
    queryFn: () =>
      fetchAll<Emission>(
        "/nl/v3/objects/fetch_all",
        {
          object: "emission",
          fields: ["id", 'start_date', 'end_date'],
          order: "id DESC"
        },
        login
      ),
    enabled: !!login
  });










  const mutationExport = useMutation({
    mutationFn: () => {
      return fetchOne<RawExportStat>(
        "/nl/v3/objects/custom_action",
        {
          object: 'exit',
          class_action: 'custom_api_exit_stats_export',
          handler_id: login?.id,
          book_year: bookYear,
          book_year_m1: bookYearMinus1,
          book_year_m2: bookYearMinus2,
          only_active: 0
        },
        login
      );
    },
    onSuccess: (data, variables, context) => {
      setSuccessE1(true);
    },
  });
  const mutationExportStrategicPlanning = useMutation({
    mutationFn: (pars: any) => {
      return fetchOne<RawExportStat>(
        "/nl/v3/objects/custom_action",
        pars,
        login
      );
    },
    onError: (data, variables, context) => {
      console.log(variables);
      if (variables.uittredingen === 1) setFailE1(true);
      if (variables.overlijdens_jaar_maand === 1) setFailE2(true);
      if (variables.overdrachten_leeftijd_kapitaal === 1) setFailE3(true);
      if (variables.verdeling_overlijdens === 1) setFailE4(true);
      if (variables.emission_stats === 1) setFailE5(true);
    },
    onSuccess: (data, variables, context) => {
      if (variables.uittredingen === 1) setSuccessE1(true);
      if (variables.overlijdens_jaar_maand === 1) setSuccessE2(true);
      if (variables.overdrachten_leeftijd_kapitaal === 1) setSuccessE3(true);
      if (variables.verdeling_overlijdens === 1) setSuccessE4(true);
      if (variables.emission_stats === 1) setSuccessE5(true);
    },
  });








  // useEffect(() => {
  //   getBookYears();
  // }, [login]);











  return <Page sx={{}} title="Statistical Exports And Filters" helper="seaf">
    <Grid container spacing="8">
      <Grid item xs={12}>
        <Typography variant="h3">Exit Stats</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Book Year Base (current)"
          value={bookYear?.toString() || ''}
          id='book_year'
          onChange={(v) => {setBookYear(parseInt(v, 10));}}
          list={[
            {id: '', name: "Unselected"},
            ...((bookYears || []).map(by => {return {id: by.id?.toString() || '', name: by.short_visual};}))
          ]}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Book Year Previous"
          value={bookYearMinus1?.toString() || ''}
          id='book_year'
          onChange={(v) => {setBookYearMinus1(parseInt(v, 10));}}
          list={[
            {id: '', name: "Unselected"},
            ...((bookYears || []).map(by => {return {id: by.id?.toString() || '', name: by.short_visual};}))
          ]}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Book Year Two Ago"
          value={bookYearMinus2?.toString() || ''}
          id='book_year'
          onChange={(v) => {setBookYearMinus2(parseInt(v, 10));}}
          list={[
            {id: '', name: "Unselected"},
            ...((bookYears || []).map(by => {return {id: by.id?.toString() || '', name: by.short_visual};}))
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        <StyledButton
          label="Manual export"
          id='uittredingen'
          disabled={!bookYear}
          contained
          onClick={(v) => {
            mutationExportStrategicPlanning.mutate({
              object: 'user',
              class_action: 'strategic_planning_export',
              id: login?.id,
              uittredingen: 1,
              by: bookYear,
              bym1: bookYearMinus1,
              bym2: bookYearMinus2
            });
          }}
          sx={{
            // marginLeft: 1
          }}
        />
      </Grid>
      {successE1 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.tertiary?.main}}>SEAF successvol doorgestuurd. U zal een email ontvangen.</Typography>
      </Grid>}
      {failE1 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.secondary?.main}}>SEAF doorgestuurd. Error of timeout. Check de exports, of trek aan Nico zijn mouw.</Typography>
      </Grid>}
      <Grid item xs={12}>
        <Divider sx={{marginTop: 4, marginBottom: 4}} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h3">Overlijdens jaar maand</Typography>
      </Grid>
      <Grid item xs={12}>
        <StyledButton
          label="Manual export"
          id='export_overlijdens_jaar_maand'
          contained
          onClick={(v) => {
            mutationExportStrategicPlanning.mutate({
              object: 'user',
              class_action: 'strategic_planning_export',
              id: login?.id,
              overlijdens_jaar_maand: 1
            });
          }}
          sx={{
            // marginLeft: 1
          }}
        />
      </Grid>
      {successE2 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.tertiary?.main}}>SEAF successvol doorgestuurd. U zal een email ontvangen.</Typography>
      </Grid>}
      {failE2 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.secondary?.main}}>SEAF doorgestuurd. Error of timeout. Check de exports, of trek aan Nico zijn mouw.</Typography>
      </Grid>}
      <Grid item xs={12}>
        <Divider sx={{marginTop: 4, marginBottom: 4}} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h3">Bubbles (Overdrachten leeftijd kapitaal)</Typography>
      </Grid>
      <Grid item xs={12}>
        <StyledButton
          label="Manual export"
          id='overdrachten_leeftijd_kapitaal'
          contained
          onClick={(v) => {
            mutationExportStrategicPlanning.mutate({
              object: 'user',
              class_action: 'strategic_planning_export',
              id: login?.id,
              overdrachten_leeftijd_kapitaal: 1
            });
          }}
          sx={{
            // marginLeft: 1
          }}
        />
      </Grid>
      {successE3 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.tertiary?.main}}>SEAF successvol doorgestuurd. U zal een email ontvangen.</Typography>
      </Grid>}
      {failE3 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.secondary?.main}}>SEAF doorgestuurd. Error of timeout. Voor deze kan dat normaal zijn. Zie of je een mail hebt gekregen.</Typography>
      </Grid>}
      <Grid item xs={12}>
        <Divider sx={{marginTop: 4, marginBottom: 4}} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h3">Verdeling overlijdens (YTD)</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Book Year Base (current)"
          value={bookYear?.toString() || ''}
          id='book_year'
          onChange={(v) => {setBookYear(parseInt(v, 10));}}
          list={[
            {id: '', name: "Unselected"},
            ...((bookYears || []).map(by => {return {id: by.id?.toString() || '', name: by.short_visual};}))
          ]}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Book Year Previous"
          value={bookYearMinus1?.toString() || ''}
          id='book_year'
          onChange={(v) => {setBookYearMinus1(parseInt(v, 10));}}
          list={[
            {id: '', name: "Unselected"},
            ...((bookYears || []).map(by => {return {id: by.id?.toString() || '', name: by.short_visual};}))
          ]}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <InputMask
          mask="99/9999"
          placeholder="mm/yyyy"
          value={activeMonth}
          onChange={(v) => {setActiveMonth(v.target.value.trim());}}
        >
          <TextField
            // value={value}
            id="monthpicker"
            variant="outlined"
            label="Maand van 'Verwerkte overlijdens xxx'"
            // onChange={(e) => {onChange(e.target.value)}}
            sx={{
              width: '100%',
              padding: 1,
              'input': {
                padding: 1
              },
              'label[data-shrink=true]': {
                left: 8,
                top: 8
              },
              'label[data-shrink=false]': {
                opacity: 0.4
              }
            }}
          />
        </InputMask>
      </Grid>
      <Grid item xs={12}>
        <StyledButton
          label="Manual export"
          id='verdeling_overlijdens'
          disabled={!bookYear || !bookYearMinus1}
          contained
          onClick={(v) => {
            mutationExportStrategicPlanning.mutate({
              object: 'user',
              class_action: 'strategic_planning_export',
              id: login?.id,
              verdeling_overlijdens: 1,
              by: bookYear,
              bym1: bookYearMinus1,
              month: ["01", activeMonth].join("/")
            });
          }}
          sx={{
            // marginLeft: 1
          }}
        />
      </Grid>
      {successE4 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.tertiary?.main}}>SEAF successvol doorgestuurd. U zal een email ontvangen.</Typography>
      </Grid>}
      {failE4 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.secondary?.main}}>SEAF doorgestuurd. Error of timeout. Voor deze kan dat normaal zijn. Zie of je een mail hebt gekregen.</Typography>
      </Grid>}
      <Grid item xs={12}>
        <Divider sx={{marginTop: 4, marginBottom: 4}} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h3">Emission Stats</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Emission"
          value={emissionId?.toString() || ''}
          id='book_year'
          onChange={(v) => {setEmissionId(parseInt(v, 10));}}
          list={[
            {id: '', name: "Unselected"},
            ...((emissions || []).map(em => {return {id: em.id?.toString() || '', name: [DateTime.fromISO(em.start_date).toFormat("D"), DateTime.fromISO(em.end_date).toFormat("D")].join(" - ")};}))
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        <StyledButton
          label="Manual export"
          id='emission_stats'
          disabled={!emissionId}
          contained
          onClick={(v) => {
            mutationExportStrategicPlanning.mutate({
              object: 'user',
              class_action: 'strategic_planning_export',
              id: login?.id,
              emission_stats: 1,
              emission_id: emissionId
            });
          }}
          sx={{
            // marginLeft: 1
          }}
        />
      </Grid>
      {successE5 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.tertiary?.main}}>SEAF successvol doorgestuurd. U zal een email ontvangen.</Typography>
      </Grid>}
      {failE5 && <Grid item xs={12}>
        <Typography sx={{fontStyle: 'italic', color: theme.palette.secondary?.main}}>SEAF doorgestuurd. Error of timeout. Voor deze kan dat normaal zijn. Zie of je een mail hebt gekregen.</Typography>
      </Grid>}
    </Grid>
  </Page>;
}
